import { DatePipe } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import {
  AdminButtonComponent,
  AdminEmptyStateComponent,
  AdminPageHeaderComponent,
  AdminTableComponent,
  StatusBadgeComponent,
} from '../../../../shared/admin';
import { FranchiseListItem, FranchisesService } from '../../../../shared/services/franchises.service';
import { AuthService } from '../../../../services/auth.service';
import { PermissionService } from '../../../permissions/permission.service';

@Component({
  selector: 'app-franchises-page',
  standalone: true,
  imports: [
    DatePipe,
    FormsModule,
    RouterLink,
    AdminPageHeaderComponent,
    AdminButtonComponent,
    AdminTableComponent,
    AdminEmptyStateComponent,
    StatusBadgeComponent,
  ],
  templateUrl: './franchises-page.component.html',
  styleUrl: './franchises-page.component.scss',
})
export class FranchisesPageComponent {
  private readonly franchisesService = inject(FranchisesService);
  private readonly authService = inject(AuthService);
  private readonly permissions = inject(PermissionService);
  private readonly router = inject(Router);

  readonly franchises = signal<FranchiseListItem[]>([]);
  statusFilter: 'all' | 'active' | 'inactive' = 'all';

  readonly showCreate = computed(() => this.permissions.canShow('franchises', 'create'));
  readonly canCreate = computed(() => this.permissions.canExecute('franchises', 'create'));

  readonly filtered = computed(() => {
    const items = this.franchises();
    if (this.statusFilter === 'active') return items.filter((f) => f.isActive);
    if (this.statusFilter === 'inactive') return items.filter((f) => !f.isActive);
    return items;
  });

  constructor() {
    this.refresh();
  }

  refresh(): void {
    this.franchisesService.list().subscribe((items) => this.franchises.set(items));
  }

  goCreate(): void {
    if (!this.canCreate()) return;
    void this.router.navigate(['/platform/franchises/new']);
  }
}
